@if (locations()) {
  <google-map
    (mapInitialized)="mapInitialized($event)"
    [options]="mapOptions"
    height="100%"
    width="100%"
  >
    @for (markerData of filteredMarkers; track markerData.id) {
      <map-advanced-marker
        (mapClick)="openInfo(advancedMarker, markerData, infoWindow)"
        [content]="markerData | avsMarkerIcon"
        [gmpDraggable]="false"
        [options]="markerData.options"
        [position]="markerData.position"
        #advancedMarker="mapAdvancedMarker"
      />
    }

    <div #infoWindow>
      @if (selectedSite) {
        <i
          class="icon-close absolute top-0 right-0 text-base text-ui-gray-100 p-1 cursor-pointer"
          (click)="hideInfo()"
        ></i>

        @if (selectedSite.incidentCountBySeverity && selectedSite.devicesByStatuses) {
          <avs-space-card-info
            [address]="selectedSite.address.country + ', ' + selectedSite.address.city + ', ' + selectedSite.address.streetAddress"
            [criticalAndMajorSeverityCount]="selectedSite.incidentCountBySeverity.critical + selectedSite.incidentCountBySeverity.major"
            [deviceActive]="selectedSite.devicesByStatuses.activeCount"
            [devicePaused]="selectedSite.devicesByStatuses.pausedCount"
            [minorSeverityCount]="selectedSite.incidentCountBySeverity.minor"
            [name]="selectedSite.friendlyName || selectedSite.name"
            [spaceLink]="['/dashboard', selectedSite.id]"
            [status]="selectedSite.status"
          />
        }
      }
    </div>
    <map-info-window />
  </google-map>
}
